import { render, staticRenderFns } from "./KOLProfile.vue?vue&type=template&id=08491438&scoped=true"
import script from "./KOLProfile.vue?vue&type=script&lang=js"
export * from "./KOLProfile.vue?vue&type=script&lang=js"
import style0 from "./KOLProfile.vue?vue&type=style&index=0&id=08491438&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08491438",
  null
  
)

export default component.exports